import { RequestContext } from '@/lib/mastra/types';
import type { TaskType } from '@/types/assistant';
import type { SiteBrandContext } from '@/types/page';

interface BuildCompletionOptionsParams extends SiteBrandContext {
  userId: string;
  accountId: string | null;
  task: TaskType;
  threadId: string;
}

/**
 * Builds standardized completion agent options for both streaming and synchronous completions.
 * Centralizes the configuration logic to ensure consistency across different completion hooks.
 */
export function buildCompletionOptions({
  userId,
  accountId,
  task,
  threadId,
  preferences,
  firmContext,
}: BuildCompletionOptionsParams) {
  const requestContext = new RequestContext();
  requestContext.set('task', task);
  requestContext.set('preferences', preferences || {});
  requestContext.set('firmContext', firmContext || {});

  const options = {
    memory: {
      resource: `${userId}:${accountId}:completion`,
      thread: {
        id: threadId,
        metadata: {
          accountId,
          task,
          type: 'completion',
          agentId: 'completion',
          agentCategory: 'Page Editor',
        },
      },
    },
    requestContext,
  };

  return options;
}
